export default {
    
    LOAD_PROVIDERS (state, providers) {
        state.items = providers
    }

    
}